function loop(theme, res, list, type) {
  const suffixes = { main: '', light: 'Light', dark: 'Dark' };
  const suffixe = suffixes[type];
  const contrasts = { main: 'contrastText', light: 'contrastLightText', dark: 'contrastDarkText' };
  const contrast = contrasts[type];
  list.forEach(key => {
    res[`${key}${suffixe}`] = {
      borderColor: theme.palette[key][type],
      color: theme.palette[key][type],
      '&:hover': {
        backgroundColor: theme.palette[key][type],
        color: theme.palette[key][contrast],
      },
    };
    res[`${key}${suffixe}2`] = {
      borderColor: theme.palette[key][contrast],
      color: theme.palette[key][contrast],
      '&:hover': {
        backgroundColor: theme.palette[key][contrast],
        color: theme.palette[key][type],
      },
    };
  });
}

export default theme => {
  const mains = ['grey', 'green', 'blue', 'yellow', 'red', 'orange', 'pink', 'purpule'];
  const light = ['green', 'blue'];
  const dark = ['purpule'];

  const res = {
    button: {
      borderRadius: 20,
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      textTransform: 'uppercase',
      borderStyle: 'solid',
      borderWidth: 1,
      fontWeight: 500,
      lineHeight: 1.75,
      letterSpacing: '0.02857em',
      backgroundColor: 'transparent',
      transition: 'color 0.3s, background-color 0.3s',
    },
    label: {
      width: '100%',
      textAlign: 'center',
    },
    medium: {
      fontSize: '0.875rem',
      padding: '5px 15px',
    },
    small: {
      padding: '2px 12px',
      fontSize: '0.70rem',
    },
  };

  loop(theme, res, mains, 'main');
  loop(theme, res, light, 'light');
  loop(theme, res, dark, 'dark');

  return res;
};
